import { createFileRoute, redirect } from "@tanstack/react-router";
import { rememberedPlatformRedirect } from "@/lib/launch-place";
import { guardLaunchRoute } from "@/components/launch/launch-route-guard";
import { launchEditSearchSchema } from "@/lib/search-params";
import LaunchEditView from "@/components/launch/edit/LaunchEditPage";
import { loadLaunchEditData } from "@/components/launch/edit/launch-edit-route";

export const Route = createFileRoute("/_authenticated/$orgSlug/launch/edit")({
  validateSearch: launchEditSearchSchema,
  beforeLoad: async (args) => {
    await guardLaunchRoute(args);
    // No platform in the URL: reopen the one last used here rather than Meta.
    // A deep link with its own account keeps whatever it asked for.
    if (args.search?.account) return;
    const target = rememberedPlatformRedirect("edit", args.params.orgSlug, args.search);
    if (target) throw redirect(target);
  },
  loader: loadLaunchEditData,
  // Search text, selection and sort are page state; a workspace switch starts over.
  remountDeps: ({ params }) => params.orgSlug,
  component: LaunchEditPage,
});

function LaunchEditPage() {
  return (
    <LaunchEditView
      route={{
        useLoaderData: () => Route.useLoaderData(),
        useParams: () => Route.useParams(),
        useSearch: () => Route.useSearch(),
      }}
    />
  );
}
